import React, { useState, useEffect, useContext } from 'react';
import { API_BASE_URL, UBICACIONES_SECCIONES_VALIDAS } from '../config/constants';
import axios from 'axios';
import { signOut } from 'firebase/auth';
import { auth } from './login/FirebaseConfig';
import { AuthContext } from './login/AuthContext';
import { Row, Col } from 'react-bootstrap'
import "../css/Footer2.css"

const Footer = () => {
  const { user } = useContext(AuthContext);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log('Sesión cerrada correctamente!');
    } catch (err) {
      console.error('Error al cerrar sesión: ', err);
    }
  };

  return (
    <div>
      <footer className="footer">
          <Row className="footer-columns mx-5 mt-3">
            <Col xs={12} md={4} className="footer-secciones-container">
              <p className="text-footer mb-2 d-block">
                Enviá tu CV a: <br />
                cv@bingobahia.com
              </p>
              <a href={`/terminosycondiciones`} className="text-footer mb-1 d-block">
                {"Términos y Condiciones"}
              </a>
              <a href={`/politicadeprivacidad`} className="text-footer mb-1 d-block">
                {"Política de privacidad"}
              </a>
              <hr id="footer-separator" />
              {user ? (
                <p onClick={handleLogout} style={{ cursor: 'pointer' }}>
                  Cerrar Sesión
                </p>
              ) : (
                <p style={{ cursor: 'pointer' }}>
                  <a className="text-footer">

                  </a>
                </p>
              )}
            </Col>
            <Col xs={12} md={4}></Col>
            <Col xs={12} md={4} className="footer-logo d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column align-items-center div-loteria">
                <img
                  src="/imagenes/footer/logo_loteria PNG.png"
                  alt="Loteria Logo"
                  className="img-fluid w-100 logo-loteria"
                  style={{ maxHeight: '600px', objectFit: 'cover'}}
                  loading="lazy"
                />
              </div>
            </Col>
          </Row>
        <br />
        <Row>
          <Col md={4} className="mb-md-4">
            <div className="px-5" style={{ textAlign: "left" }}>
              <p>
                Todos los derechos
                reservados.
                Sitio desarrollado para
                brindar una experiencia
                segura y divertida.
              </p>
              <p>© 2025 Bingo.</p>
            </div>
          </Col>
          <Col md={4} className="mb-md-4">
            <div className="px-5" style={{ textAlign: "left" }}>
              <p>
                Sólo mayores de 18
                años. El juego compulsivo es
                perjudicial para la salud.
              </p>
              <p>Resolución N° 3384/04.</p>
            </div>
          </Col>
          <Col md={4} className="mb-md-4">
            <div className="px-5" style={{ textAlign: "left" }}>
              <p>
                Si tenés problemas con el juego podés
                llamar gratis al 0800-444-4000 las
                24 horas, los 365 días del año.
                Programa de Prevención y Asistencia
                al Juego Compulsivo del Instituto
                Provincial de Lotería y Casinos de
                la Provincia de Buenos Aires.
              </p>
            </div>
          </Col>
        </Row>
        <img className="img-fluid bingo-footer-logo" src='/imagenes/Logos/logoverticalblanco.png' alt='Logo Bingo Bahía'></img>
        <p className="text-footer text-center">Chiclana 250, Belgrano 39, Bahía Blanca, Buenos Aires.</p>
      </footer>
      <footer className="footer-inferior py-2 px-4">
        <a href="https://www.facebook.com/bingo.bahia" target="_blank" rel="noopener noreferrer" className='mx-3'>
          <img src="/imagenes/footer/facebooklogo.png" alt="Facebook Logo" />
        </a>
        <a href="https://www.instagram.com/bingo.bahia" target="_blank" rel="noopener noreferrer">
          <img src="/imagenes/footer/instagramlogo.png" alt="Instagram Logo" />
        </a>
      </footer>
    </div>
  );
}

export default Footer;
